// Function checks if a scanned id (of a batch or a card) is that of the user's card stored
// in local storage as part of his token, i.e checks if user is trying to sign out using his card.

const isSignOut = (id) => {
    const user = JSON.parse(localStorage.getItem('user_id'));
    return user ? id === user.cardId : false;
};

export default isSignOut;
